"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTreeForElement = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _Player = require("../../Player");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getTreeForElement = exports.getTreeForElement = function getTreeForElement(list, parentId) {
  var result = {};
  var getParent = function getParent(id) {
    // Reset show conditions rules just to show hidden tree in preview mode
    if ((0, _get2["default"])(result[id], 'settings.showConditionsRules')) {
      result[id].settings.showConditionsRules = null;
    }
    var parent = (0, _find2["default"])(list, function (element) {
      return element.children && element.children.includes(id);
    });
    if (parent) {
      result[parent.id] = (0, _cloneDeep2["default"])(parent);
      result[parent.id].children = [id];
      if (parent.id !== 0) {
        result[parent.id].skipPlaying = true;
      }
      getParent(parent.id);
    }
  };
  var getElementWithChildren = function getElementWithChildren(id) {
    result[id] = (0, _cloneDeep2["default"])(list[id]);
    if (list[id].children) {
      list[id].children.forEach(function (child) {
        return getElementWithChildren(child);
      });
    }
  };
  getElementWithChildren(parentId);
  getParent(parentId);
  return result;
};
var Preview = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Preview, _React$Component);
  function Preview() {
    _classCallCheck(this, Preview);
    return _callSuper(this, Preview, arguments);
  }
  _createClass(Preview, [{
    key: "render",
    value: function render() {
      var list;
      if (this.props.parentId) {
        list = getTreeForElement(this.props.list, this.props.parentId);
      } else {
        list = this.props.list;
      }
      return /*#__PURE__*/_react["default"].createElement(_Player.PlayerWithoutDndContext, {
        isPreviewMode: true,
        previewList: list,
        previewSettings: this.props.settings,
        onlyOneComponent: !!this.props.parentId,
        onComplete: this.props.onComplete
      });
    }
  }]);
  return Preview;
}(_react["default"].Component);
_defineProperty(Preview, "propTypes", {
  parentId: _propTypes["default"].number,
  onComplete: _propTypes["default"].func,
  list: _propTypes["default"].object.isRequired,
  settings: _propTypes["default"].object.isRequired
});